import React, { useEffect, useRef, useState } from "react";
import Isotope from "isotope-layout";
import ProjectDetailsModal from "./ProjectDetailsModal";
const Portfolio = () => {
  // init one ref to store the future isotope object
  const isotope = useRef();
  // store the filter keyword in a state
  const [filterKey, setFilterKey] = useState("*");
  const [imagesLoaded, setimagesLoaded] = useState(0);
  const [selectedProjectDetails, setSelectedProjectDetails] = useState();
  const [isOpen, setIsOpen] = useState(false);

  const htmlElement = document.getElementsByTagName("html")[0];
  const isRtl = htmlElement.getAttribute("dir") === "rtl";

  const filters = {
    DETAILED: "Details",
    MOCKUPS: "Mockups",
    YOUTUBE: "Youtube Videos",
    VIMEO: "Vimeo Videos",
  };

  const types = {
    IMAGE: "image",
    VIDEO: "video",
    LIBRARY: "library",
  };

  const projectsData = [
    {
      title: "CorrePy",
      type: types.LIBRARY,
      document: {
        projectInfo:
          "CorrePy is a powerful Python library designed to streamline the process of extracting transaction information from brokerage notes in PDF format, specifically for stock market purchases and sales. This versatile tool provides a seamless solution for traders, investors, and financial professionals who need to efficiently process and analyze their stock market activities.",
        technologies: "Python",
        url: {
          name: "CorrePy",
          link: "https://github.com/thiagosalvatore/correpy/tree/main",
        },

        sliderImages: [
        ],
      },

      thumbImage: "images/projects/correpy.jpeg",

      categories: [filters.DETAILED],
    },
    {
      title: "StatusInvestPy",
      type: types.LIBRARY,
      document: {
        projectInfo: "StatusInvestPy is a dedicated Python library engineered to simplify the process of fetching stock data from the renowned financial website, StatusInvest, and transforming it into a structured JSON format. This versatile tool empowers traders, investors, and financial analysts with the ability to effortlessly access and analyze stock market data directly from StatusInvest.",
        technologies: "Python, BeautifulSoup",
        url: {
          name: "StatusInvestPy",
          link: "https://github.com/thiagosalvatore/statusinvest-py",
        },

        sliderImages: [
        ],
      },

      thumbImage: "images/projects/statusinvestpy.jpeg",

      categories: [filters.DETAILED],
    }
  ];

  // initialize an Isotope object with configs
  useEffect(() => {
    isotope.current = new Isotope(".portfolio-filter", {
      itemSelector: ".filter-item",
      layoutMode: "masonry",
      originLeft: !isRtl,
    }, [isRtl]);

    // cleanup
    return () => {
      isotope.current.destroy();
    };
  }, []);

  // handling filter key change
  useEffect(() => {
    if (imagesLoaded) {
      filterKey === "*"
        ? isotope.current.arrange({ filter: `*` })
        : isotope.current.arrange({ filter: `.${filterKey}` });
    }
  }, [filterKey, imagesLoaded]);

  const handleFilterKeyChange = (key) => () => setFilterKey(key);

  const getKeyByValue = (value) => {
    return Object.keys(filters).find((key) => filters[key] === value);
  };

  const getFilterClasses = (categories) => {
    if (categories.length > 0) {
      let tempArray = [];
      categories.forEach((category, index) => {
        tempArray.push(getKeyByValue(category));
      });
      return tempArray.join(" ");
    }
  };

  return (
    <>
      <section id="portfolio" className={"section bg-light"}>
        <div className={"container"}>
          {/* Heading */}
          <p className="text-center mb-2 wow fadeInUp">
            <span className="bg-primary text-dark px-2">Portfolio</span>
          </p>
          <h2 className="text-10 fw-600 text-center mb-5 wow fadeInUp">
            Most recent open-source projects
          </h2>
          {/* Heading end*/}
          {/* Filter Menu */}
          {/*<ul*/}
          {/*  className={*/}
          {/*    "portfolio-menu nav nav-tabs fw-600 justify-content-start justify-content-md-center border-bottom-0 mb-5 wow fadeInUp"*/}
          {/*  }*/}
          {/*>*/}
          {/*  <li className="nav-item">*/}
          {/*    <button*/}
          {/*      className={"nav-link " + (filterKey === "*" ? "active" : "")}*/}
          {/*      onClick={handleFilterKeyChange("*")}*/}
          {/*    >*/}
          {/*      All*/}
          {/*    </button>*/}
          {/*  </li>*/}
          {/*  {Object.keys(filters).map((oneKey, i) => (*/}
          {/*    <li className="nav-item" key={i}>*/}
          {/*      <button*/}
          {/*        className={*/}
          {/*          "nav-link " + (filterKey === oneKey ? "active" : "")*/}
          {/*        }*/}
          {/*        onClick={handleFilterKeyChange(oneKey)}*/}
          {/*      >*/}
          {/*        {filters[oneKey]}*/}
          {/*      </button>*/}
          {/*    </li>*/}
          {/*  ))}*/}
          {/*</ul>*/}
          {/*/!* Filter Menu end *!/*/}
          <div className="portfolio wow fadeInUp">
            <div className="row portfolio-filter filter-container g-4">
              {projectsData.length > 0 &&
                projectsData.map((project, index) => (
                  <div
                    className={
                      "col-sm-6 col-lg-4 filter-item " +
                      getFilterClasses(project.categories)
                    }
                    key={index}
                  >
                    <div className="portfolio-box">
                      <div className="portfolio-img">
                        <img
                          onLoad={() => {
                            setimagesLoaded(imagesLoaded + 1);
                          }}
                          className="img-fluid d-block portfolio-image"
                          src={project.thumbImage}
                          alt=""
                        />
                        <div
                          className="portfolio-overlay"
                          onClick={() => {
                            setSelectedProjectDetails(projectsData[index]);
                            setIsOpen(true);
                          }}
                        >
                          <button className="popup-ajax stretched-link border-0 p-0 ">
                            {" "}
                          </button>
                          <div className="portfolio-overlay-details">
                            <p className="text-primary text-8">
                              {project.type === types.LIBRARY && (
                                <i className="fas fa-book-alt"></i>
                              )}
                              {project.type === types.IMAGE && (
                                <i className="fas fa-image"></i>
                              )}
                              {project.type === types.VIDEO && (
                                <i className="fas fa-video"></i>
                              )}
                            </p>
                            <h5 className="text-white text-5">
                              {project?.title}
                            </h5>
                            <span className="text-light">Category</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
            </div>
          </div>
        </div>
      </section>
      {/* Modal */}
      {isOpen && (
        <ProjectDetailsModal
          projectDetails={selectedProjectDetails}
          setIsOpen={setIsOpen}
        ></ProjectDetailsModal>
      )}
    </>
  );
};

export default Portfolio;
